/**
 * ContractAutocomplete — 사용자PC(/u/orders) bizform(거래명세서/세금계산서) 팝업의
 *                        결제처(거래처)명 자동완성 드롭다운.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 전역함수 checkInfoChangeCont / GetcontractListSelA /
 * showAllCList / searchCompleateCont / serCompleteNameuse / deleteMyConameone /
 * get_mem_ContactLists (+ 상태 member_contact_nameList / autoCompleteTarInput) 를 캡슐화했다.
 *
 * 외부(레거시)에서 호출되는 진입점 → $j.Pages.Desktop.Orders.initialize() 가 window 로 브리지:
 *   - window.checkInfoChangeCont(tarid)      : bizform.php onkeyup
 *   - window.showAllCList(tarID)             : bizform.php onclick
 *   - window.GetcontractListSelA(onum,taxnum): bizform.php onclick
 *   - window.serCompleteNameuse(str,tel,no)  : _renderList 이 만든 드롭다운 항목 onclick
 *   - window.deleteMyConameone(contconum)    : 드롭다운 삭제 onclick
 *   - window.get_mem_ContactLists(act)       : u-order-edit.js (reloadContacts)
 *   (searchCompleateCont 은 내부 전용이라 노출하지 않는다 → _renderList)
 *
 * ⚠ 결합 (step4 bizform 편집기 이관 시 정리 대상)
 * ────────────────────────────────────────────────
 * 아직 레거시 전역/함수에 의존한다. 모듈은 strict 이므로 전부 window.* 로 접근한다:
 *   - u-order-edit.js : window.coBoxCalTar, window.get_Other_DocList, window.getMyDocInfoSet, window.popwinOrdernum
 *   - blade inline    : window.other_co_Docs, window.ontractListOpenTab, window.onList
 *   - u-order-list.js : window.reLoadOrderNums, window.reLoadOrderNumsNo
 *   - 공통            : window.swalert, window.orderTax
 *
 * 서버: GET /u/ajax/order-tax/contract-names · POST /u/ajax/order-tax/contract-name(+/delete)
 */
import Util from '../../../Common/Util';

// onclick="f('…')" 의 JS 문자열 인자 — JS 이스케이프 뒤 HTML 이스케이프 (속성은 디코딩된 뒤 JS 로 읽힌다)
const jsArg = (v) => Util.escapeHtml(String(v ?? '').replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/[\r\n]/g, ' '));
export default class ContractAutocomplete {
    constructor() {
        this._nameList = null;    // (구)member_contact_nameList : 거래처명 자동완성 캐시
        this._targetInput = null; // (구)autoCompleteTarInput    : 현재 입력 대상 <input>
    }

    /** bizform onkeyup — 입력 변경 감지 → 저장버튼 활성 + 자동완성 갱신 (구 checkInfoChangeCont) */
    onInputChange = (tarid) => {
        var tar = document.getElementById(tarid);
        this._targetInput = tar;
        var old = tar.getAttribute("oldval") + document.getElementById("played_co_tel").getAttribute("oldval");
        var nvv = tar.value.trim() + document.getElementById("played_co_tel").value.trim();
        var btn = document.getElementById("checkInfoChangeContBtn");
        if (old != nvv) {
            btn.style.backgroundColor = "#E3F7F7";
            btn.style.border = "1px solid #C1C1C1";
            btn.disabled = false;
        } else {
            btn.style.backgroundColor = "#E3E3E3";
            btn.style.border = "1px solid #C1C1C1";
            btn.disabled = false;
        }
        if (this._nameList == null) {
            this.loadList(-1);
        } else {
            this._renderList(-1);
        }
    }

    /** bizform onclick — 입력한 거래처명을 오더에 저장 (구 GetcontractListSelA) */
    save = (ordernum, taxnum) => {
        var cname = document.getElementById("played_co_name").value;
        var ctel = document.getElementById("played_co_tel").value;

        if (cname.length < 2) { Util.swalert("최소 2자 이상 입력해 주세요"); return; }
        ordernum = parseInt(ordernum);
        if (isNaN(ordernum)) ordernum = 0;
        if (ordernum < 10) { Util.swalert("연결된 오더 번호가 없습니다."); return; }
        var sendData = { "ordernum": ordernum, "taxnum": taxnum, "contractname": cname, "cotel": ctel };
        var adr = "/u/ajax/order-tax/contract-name";
        $.ajax({
            type: "POST", url: adr, data: sendData, success: (data) => {
                if (data.inserted) {
                    this.loadList(-99);
                }
                window.reLoadOrderNums = [window.popwinOrdernum];
                window.onList = [window.popwinOrdernum];
                window.reLoadOrderNumsNo = 0;
            }
        });
    }

    /** bizform onclick — 전체 거래처 목록 드롭다운 열기/닫기 (구 showAllCList) */
    showAll = (tarID) => {
        var obj = document.getElementById("contractListSelATop");
        if (obj.style.display == "block" && window.ontractListOpenTab == 1) { obj.style.display = "none"; return; }
        var tar = document.getElementById(tarID);
        if (!tar) return;
        window.coBoxCalTar = null;
        if (window.other_co_Docs == null) window.get_Other_DocList("");

        window.ontractListOpenTab = 1;
        this._targetInput = tar;
        if (this._nameList == null) {
            this.loadList(9);
        } else {
            this._renderList(9);
        }
    }

    /** 자동완성 드롭다운 렌더 (내부 전용, 구 searchCompleateCont) */
    _renderList = (act) => {
        var obj = document.getElementById("contractListSelA");
        if (this._targetInput == null) return;
        var RT = this._targetInput.getBoundingClientRect();
        obj.innerHTML = "";
        var ret = "";
        var cc = this._targetInput.value;

        for (var i = 0; i < this._nameList.length; i++) {
            var ch = this._nameList[i];
            if (cc == ch[0] || ch[1].indexOf(cc) >= 0 || act == 9) {
                // 거래처명·번호는 회원 입력값 — onclick 의 JS 문자열 인자와 본문 양쪽을 막는다
                var jn = jsArg(ch[1]), jp = jsArg(ch[2]), n4 = Util.int(ch[4]), n3 = Util.int(ch[3]);
                var ean = "<div style='display:inline-block; width:40%;text-align:left;padding-left:10px' class='contserpopcpin' onclick=\"serCompleteNameuse('" + jn + "','" + jp + "', " + n4 + ")\">" + Util.escapeHtml(ch[1]) + "</div>";
                ean += "<div style='display:inline-block; width:42%;text-align:left'  class='contserpopcpin' onclick=\"serCompleteNameuse('" + jn + "','" + jp + "', " + n4 + ")\">" + Util.escapeHtml(ch[2]) + "</div>";
                ean += "<div style='display:inline-block; width:12%;text-align:left; color:#FF0000' class='contserpopcpin' onclick=\"deleteMyConameone(" + n3 + ")\">삭제</div>";
                ret += "<div class='contserpopcp' >" + ean + "</div>";
            }
        }
        var objTop = document.getElementById("contractListSelATop");
        if (ret == "") {
            objTop.style.display = "none";
            return;
        }

        obj.innerHTML = ret;
        objTop.style.width = "450px";
        objTop.style.left = RT.left + "px";
        objTop.style.top = parseInt(RT.bottom + 5) + "px";
        objTop.style.display = "block";

        document.getElementById("PPADD").style.display = "none";
        document.getElementById("PPClose").style.width = "100%";
    }

    /** 드롭다운 항목 선택 (구 serCompleteNameuse) */
    use = (str, tel, tarno) => {
        this._targetInput.value = str;
        document.getElementById("played_co_tel").value = tel;
        this.onInputChange("played_co_name");
        var obj = document.getElementById("contractListSelATop");
        obj.style.display = "none";
        tarno = parseInt(tarno);
        if (isNaN(tarno)) tarno = 0;
        if (tarno > 0) {
            if (window.other_co_Docs != null) {
                if (typeof (window.other_co_Docs) != "object") {
                    window.other_co_Docs = [];
                }
                for (var i = 0; i < window.other_co_Docs.length; i++) {
                    var ea = window.other_co_Docs[i];
                    var eano = parseInt(ea.rsno); if (isNaN(eano)) eano = 0;
                    if (eano == tarno) {
                        var obj2 = document.getElementById("checkInfoChangeContBtn");
                        var onum = parseInt(obj2.getAttribute("onum")); if (isNaN(onum)) onum = 0;
                        var taxnum = parseInt(obj2.getAttribute("taxnum")); if (isNaN(taxnum)) taxnum = 0;
                        if (taxnum > 0 && onum > 0) {
                            this.save(onum, taxnum);
                            window.getMyDocInfoSet(i, 2);
                        }
                    }
                }
            }
        }
    }

    /** 드롭다운 항목 삭제 (구 deleteMyConameone) */
    deleteName = (contconum) => {
        var adr = "/u/ajax/order-tax/contract-name/delete";
        var sendData = { "contconum": contconum };
        $.ajax({
            type: "POST", url: adr, data: sendData, success: (data) => {
                var co_name = document.getElementById("played_co_name").value;
                if (co_name.length > 0) {
                    this.loadList(1);
                } else {
                    this.loadList(9);
                }
            }
        });
    }

    /** 거래처명 목록 로드 (구 get_mem_ContactLists). act==-99 면 렌더 생략(캐시만 갱신) */
    loadList = (act) => {
        this._nameList = [];
        var adr = "/u/ajax/order-tax/contract-names";
        $.ajax({
            type: "GET", url: adr, success: (data) => {
                this._nameList = data;
                if (act == -99) return;
                this._renderList(act);
            }
        });
    }
}
